import { useQuery } from "@apollo/client/react";
import { first, isEmpty } from "lodash";
import { useEffect, useState } from "react";

import { pagedSearchTags } from "src/queries/tags.graphql";

const useSelectedTagValue = (value) => {
  const [selectedValue, setSelectedValue] = useState(null);
  const { loading, data } = useQuery(pagedSearchTags, {
    variables: {
      input: {
        filter: {
          tagIds: [value],
        },
      },
    },
    skip: !value || selectedValue,
  });

  useEffect(() => {
    if (!data) return;
    const tag = first(data?.results?.tags);
    if (!isEmpty(tag)) {
      setSelectedValue({
        label: tag.displayValue,
        value: tag.id,
      });
    }
  }, [data]);

  return {
    selectedValue,
    setSelectedValue,
    selectedValueLoading: loading,
  };
};

export default useSelectedTagValue;
